import { Link } from "react-router-dom";

const SERVICES = [
  "유압 회로 검토",
  "전기 회로 검토",
  "서보밸브 선정",
  "유압유니트 사양 검토",
  "모션 컨트롤러 프로그램 구성",
  "아날로그·디지털 I/O 배선 검토",
  "SSI 위치센서·압력센서 피드백 설정",
  "드라이브 파라미터 설정",
  "현장 시운전",
  "이상 진단 및 문제 해결",
];

const PROCESS = [
  { step: "01", title: "사양 검토", icon: "ri-file-search-line" },
  { step: "02", title: "회로 / 제품 선정", icon: "ri-draft-line" },
  { step: "03", title: "제품 공급", icon: "ri-truck-line" },
  { step: "04", title: "프로그램 / 파라미터", icon: "ri-code-s-slash-line" },
  { step: "05", title: "현장 시운전", icon: "ri-tools-line" },
];

export default function EngineeringServiceSection() {
  return (
    <section className="py-20 md:py-28 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start">
          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-2 text-[11px] font-semibold tracking-[0.2em] uppercase text-accent-700 mb-3">
              <span className="w-6 h-px bg-accent-500" />
              Engineering Service
            </span>
            <h2 className="text-3xl md:text-4xl font-heading font-extrabold text-foreground-950 leading-tight">
              제품만 파는 회사가 아닙니다.{" "}
              <span className="text-primary-700">
                기술이 필요한 곳에서 끝까지 함께합니다.
              </span>
            </h2>
            <p className="mt-5 text-sm md:text-base text-foreground-700 leading-relaxed">
              MC TECH는 제품 공급뿐 아니라 장비에 맞는 유압 회로, 전기 배선,
              I/O 구성, 제어 프로그램, 파라미터 설정, 현장 시운전까지
              일관되게 지원하는 엔지니어링 회사입니다.
            </p>

            <Link
              to="/engineering"
              className="mt-7 inline-flex items-center gap-2 px-5 py-3 rounded-md bg-primary-600 hover:bg-primary-700 text-background-50 font-semibold text-sm whitespace-nowrap cursor-pointer"
            >
              엔지니어링 페이지 보기
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
            </Link>

            {/* Process */}
            <div className="mt-10">
              <div className="text-[11px] font-semibold tracking-[0.2em] uppercase text-secondary-600 mb-4">
                Engineering Workflow
              </div>
              <div className="grid grid-cols-5 gap-2">
                {PROCESS.map((p, idx) => (
                  <div key={p.step} className="text-center">
                    <div className="relative">
                      <div className="w-10 h-10 mx-auto rounded-full bg-primary-600 text-background-50 flex items-center justify-center font-heading font-bold text-xs">
                        {p.step}
                      </div>
                      {idx < PROCESS.length - 1 && (
                        <div className="absolute top-1/2 left-[calc(50%+20px)] right-0 h-px bg-primary-300" />
                      )}
                    </div>
                    <div className="mt-2 text-[10px] md:text-xs font-semibold text-foreground-800 leading-tight">
                      {p.title}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="bg-background-50 border border-background-200 rounded-2xl p-6 md:p-8">
              <div className="flex items-center justify-between mb-5">
                <div className="flex items-center gap-2">
                  <i className="ri-tools-fill w-5 h-5 flex items-center justify-center text-accent-600" />
                  <span className="text-sm font-heading font-bold text-foreground-950">
                    Technical Support Coverage
                  </span>
                </div>
                <span className="text-[11px] font-semibold tracking-wider text-secondary-600">
                  10 SERVICES
                </span>
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {SERVICES.map((s, i) => (
                  <div
                    key={s}
                    className="flex items-center gap-3 bg-background-100 border border-background-200 rounded-lg px-4 py-3"
                  >
                    <div className="w-7 h-7 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center shrink-0">
                      <span className="text-[11px] font-heading font-bold">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                    </div>
                    <span className="text-sm font-semibold text-foreground-900">
                      {s}
                    </span>
                  </div>
                ))}
              </div>

              <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-3">
                <div className="bg-primary-50 border border-primary-100 rounded-lg p-4">
                  <div className="text-[10px] font-semibold tracking-[0.2em] uppercase text-primary-700">
                    Standard
                  </div>
                  <div className="mt-1 text-sm font-bold text-foreground-950">
                    Analog 4~20mA / ±10V
                  </div>
                </div>
                <div className="bg-accent-50 border border-accent-100 rounded-lg p-4">
                  <div className="text-[10px] font-semibold tracking-[0.2em] uppercase text-accent-700">
                    Feedback
                  </div>
                  <div className="mt-1 text-sm font-bold text-foreground-950">
                    SSI · Pressure · Position
                  </div>
                </div>
                <div className="bg-secondary-100 border border-secondary-200 rounded-lg p-4">
                  <div className="text-[10px] font-semibold tracking-[0.2em] uppercase text-secondary-700">
                    Interface
                  </div>
                  <div className="mt-1 text-sm font-bold text-foreground-950">
                    EtherCAT · PLC · MSC III
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}